module.exports = __webpack_public_path__ + "img/2.e47c8d17.png";